import { ApolloLink } from './ApolloLink';
export var empty = ApolloLink.empty;
//# sourceMappingURL=empty.js.map